const meaulist = [
  {
    menuName: "概况",
    url: "/home/workSpace",
    icon: "iconshouye",
    children: []
  },
  {
    menuName: "小程序",
    url: "/home/applet",
    icon: "iconxiaochengxu",
    children: [
      {
        menuName: "名片管理",
        url: "/home/applet/card"
      },
      {
        menuName: "动态管理",
        url: "/home/applet/moments"
      },
      {
        menuName: "官网装修",
        url: "/home/applet/appletDesign"
      },
      {
        menuName: "小程序配置",
        url: "/home/applet/appletsettings"
      },
      {
        menuName: "推广路径",
        url: "/home/applet/extension"
      }
    ]
  },
  {
    menuName: "商城",
    url: "/home/shopmall",
    icon: "icongouwu",
    children: [  
      {
        menuName: "积分商城",
        url: "/home/shopmall/integral"
      },          
      {
        menuName: "商品管理",
        url: "/home/shopmall/goods"
      },
      {
        menuName: "商城页面装修",
        url: "/home/shopmall/decoration"
      },
      {
        menuName: "订单售后",
        url: "/home/shopmall/order"
      },
      {
        menuName: "特权折扣",
        url: "/home/shopmall/discount"
      },      
      {
        menuName: "商城配置",
        url: "/home/shopmall/shopmallsettings"
      },
      {
        menuName: "运费管理",
        url: "/home/shopmall/freightmanage"
      }
    ]
  },

  {
    menuName: "营销",
    url: "/home/analytics",
    icon: "iconyingxiao1",
    children: [
      {
        menuName: "宣传册",
        url: "/home/analytics/brochure"
      },
      {
        menuName: "表单",
        url: "/home/analytics/form"
      },
      {
        menuName: "分销",
        url: "/home/analytics/distribution"
      },      
      {
        menuName: "获客文章",
        url: "/home/analytics/material"
      },
      {
        menuName: "公众号设置",
        url: "/home/analytics/official"
      },
      {
        menuName: "任务商机",
        url: "/home/analytics/opportunity"
      },
      {
        menuName: "视频",
        url: "/home/analytics/marketVideo"
      },
      {
        menuName: "企业相册",
        url: "/home/analytics/album"
      }
    ]
  },
  {
    menuName: "合伙人系统",
    url: "/home/partner",
    icon: "iconqianbao-copy",
    children: [
      {
        menuName: "汇总分析",
        url: "/home/partner/summary"
      },
      {
        menuName: "分红方案",
        url: "/home/partner/scheme"
      },
      {
        menuName: "添加合伙人",
        url: "/home/partner/add"
      },
      {
        menuName: "购买订单",
        url: "/home/partner/buy"
      },
      {
        menuName: "客源记录",
        url: "/home/partner/customerRecord"
      },
      {
        menuName: "入股记录",
        url: "/home/partner/rugu"
      },
    ]
  },
  {
    menuName: "活动拓客",
    url: "/home/tuoke",
    icon: "iconmas-client-line",
    children: [
      {
        menuName: "活动数据",
        url: "/home/tuoke/tkWorkSpace"
      },
      {
        menuName: "活动管理",
        url: "/home/tuoke/tkAnalytics"
      },
      {
        menuName: "日志管理",
        url: "/home/tuoke/tkJournal"
      },
      {
        menuName: "资金管理",
        url: "/home/tuoke/tkFundManage"
      },
      {
        menuName: "分销员认证",
        url: "/home/tuoke/tkShenhe"
      },
      {
        menuName: "联盟商家",
        url: "/home/tuoke/tkMerchant"
      },
    ]
  },
  {
    menuName: "客户",
    url: "/home/customer",
    icon: "iconmas-client-line",
    children: [
      {
        menuName: "客户列表",
        url: "/home/customer"
      },
      {
        menuName: "标签管理",
        url: "/home/customerLebel"
      }
    ]
  },

  {
    menuName: "员工",
    url: "/home/employee",
    icon: "iconyuangongguanli",
    children: [
      {
        menuName: "员工管理",
        url: "/home/employee/manage"
      },
      {
        menuName: "角色管理",
        url: "/home/employee/enployeemanage"
      },
      {
        menuName: "雷达权限管理",
        url: "/home/employee/roles"
      },
      {
        menuName: "工作交接",
        url: "/home/employee/handover"
      },
      {
        menuName: "锁粉设置",
        url: "/home/employee/lockguest"
      }
    ]
  },

  {
    menuName: "财务",
    url: "/home/finance",
    icon: "iconqianbao-copy",
    children: [
      {
        menuName: "佣金管理",
        url: "/home/finance/commissions"
      },
      {
        menuName: "退款订单",
        url: "/home/finance/refundOrder"
      }
    ]
  },

  {
    menuName: "设置",
    url: "/home/settings",
    icon: "iconicon17",
    children: [
      {
        menuName: "企业信息",
        url: "/home/settings/enterprise"
      },
      {
        menuName: "授权管理",
        url: "/home/settings/authorization"
      },
      {
        menuName: "App启动页",
        url: "/home/settings/startUp"
      },
      // {
      //   menuName: "开放平台",
      //   url: "/home/settings/openplatform"
      // },
      {
        menuName: "支付设置",
        url: "/home/settings/payment"
      }
    ]
  },
  {
    menuName: "意见反馈",
    url: "/home/feedback/feedbackList",
    icon: "iconfankui",
    children: []
  }
  
];

// export default meaulist;
// export default homebottomlist;
export default {
  meaulist: meaulist
}
